import { COLORS } from "../constants";
import { ColorProp } from "../constants/type";

export const getColor = (color?: ColorProp) => {
  switch (color) {
    case 1:
      return COLORS.gold;
    case 2:
      return COLORS.darkGrey;
    case 3:
      return COLORS.lightGrey;
    case 4:
      return COLORS.disabledGrey;
    default:
      return COLORS.lightGrey;
  }
};
